import { Component, OnDestroy, OnInit } from '@angular/core';
import { TourMatMenuModule, TourService } from 'ngx-ui-tour-md-menu';
import { UiTourComponent } from './ui-tour.component';

@Component({
  selector: 'app-ui-tour-host',
  standalone: true,
  imports: [TourMatMenuModule, UiTourComponent],
  template: `
    <tour-step-template>
      <ng-template let-step="step">
        <app-ui-tour [step]="step" [tourService]="tourService"></app-ui-tour>
      </ng-template>
    </tour-step-template>
  `,
})
export class UiTourHostComponent implements OnInit, OnDestroy {
  tourService: TourService;

  private startSub?: { unsubscribe(): void };
  private endSub?: { unsubscribe(): void };

  constructor(tourService: TourService) {
    this.tourService = tourService;
  }

  ngOnInit(): void {
    this.startSub = this.tourService.start$.subscribe(() => {
      document.body.classList.add('tour-active');
    });
    this.endSub = this.tourService.end$.subscribe(() => {
      document.body.classList.remove('tour-active');
    });
  }

  ngOnDestroy(): void {
    this.startSub?.unsubscribe();
    this.endSub?.unsubscribe();
  }
}
